import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
    faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const AccordionItem = ({ title, children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`tc-accordion-item ${open ? 'tc-accordion-open' : ''}`}>
            <button className="tc-accordion-trigger" onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <span className={`tc-accordion-icon ${open ? 'rotated' : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </span>
            </button>
            <div className="tc-accordion-body" style={{ maxHeight: open ? '1000px' : '0' }}>
                <div className="tc-accordion-inner">
                    {children}
                </div>
            </div>

            <style>{`
                .tc-accordion-item {
                    border: 1px solid rgba(29, 106, 136, 0.15);
                    border-radius: 10px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    transition: box-shadow 0.3s ease;
                }
                .tc-accordion-item.tc-accordion-open {
                    box-shadow: 0 4px 20px rgba(29, 106, 136, 0.12);
                    border-color: rgba(29, 106, 136, 0.35);
                }
                .tc-accordion-trigger {
                    width: 100%;
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.05), rgba(0, 168, 204, 0.04));
                    border: none;
                    padding: 14px 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 0.95rem;
                    color: #1d6a88;
                    text-align: left;
                    transition: background 0.25s ease;
                }
                .tc-accordion-trigger:hover {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.1), rgba(0, 168, 204, 0.08));
                }
                .tc-accordion-open .tc-accordion-trigger {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.12), rgba(0, 168, 204, 0.1));
                    color: #002536;
                }
                .tc-accordion-icon {
                    font-size: 0.75rem;
                    color: #00a8cc;
                    transition: transform 0.3s ease;
                    flex-shrink: 0;
                    margin-left: 12px;
                }
                .tc-accordion-icon.rotated {
                    transform: rotate(180deg);
                }
                .tc-accordion-body {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.4s ease;
                }
                .tc-accordion-inner {
                    padding: 16px 20px 20px;
                    border-top: 1px solid rgba(29, 106, 136, 0.1);
                }
                .tc-accordion-inner p,
                .tc-accordion-inner ul {
                    margin-bottom: 10px;
                }
                .tc-accordion-inner ul {
                    padding-left: 20px;
                }
                .tc-accordion-inner ul li {
                    margin-bottom: 5px;
                    color: #555;
                    line-height: 1.6;
                }
            `}</style>
        </div>
    );
};

export default function TermConditions() {

    return (
        <>
            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Terms & Conditions</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Terms & Conditions</li>
                    </ul>
                </div>
            </section>

            <section className="about-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-12">
                            <div className="case-study-content">

                                <p className="case-study-description">
                                    Website: grandindigoembroidery.com<br />
                                    Last Updated: 19/02/2026
                                </p>
                                <p className="case-study-description">
                                    Welcome to Grand Indigo Embroidery. These Terms & Conditions govern your use of our website and services. By accessing our website or placing an order, you agree to comply with the terms outlined below.
                                </p>

                                {/* Section 1 */}
                                <h3 className="case-study-title">1. Company Overview</h3>
                                <p className="case-study-description">
                                    Grand Indigo Embroidery provides professional digital and production services including:
                                </p>
                                <ul>
                                    <li>Embroidery Digitizing (DST, PES, EXP, JEF, VP3, HUS and other formats)</li>
                                    <li>Vector Artwork Conversion (AI, EPS, SVG, PDF, PNG)</li>
                                    <li>Custom Embroidered Patches (iron-on, sew-on, velcro, PVC)</li>
                                    <li>DTF (Direct-to-Film) Print-Ready Designs</li>
                                    <li>Logo Redraw and Artwork Enhancement</li>
                                    <li>Custom Logo Development for Apparel & Branding</li>
                                </ul>
                                <p className="case-study-description">
                                    These services are provided digitally unless physical patch production is ordered.
                                </p>

                                {/* Section 2 */}
                                <h3 className="case-study-title">2. Acceptance of Terms</h3>
                                <p className="case-study-description">
                                    By using grandindigoembroidery.com or placing an order through email, social media, or other communication channels, you confirm that:
                                </p>
                                <ul>
                                    <li>You are at least 18 years of age.</li>
                                    <li>You agree to comply with these Terms & Conditions.</li>
                                    <li>You have authority to enter into a binding agreement.</li>
                                </ul>

                                {/* Section 3 - with accordion subheadings */}
                                <h3 className="case-study-title">3. Order Submission & Requirements</h3>

                                <AccordionItem title="3.1 Artwork Submission">
                                    <p className="case-study-description">Clients must provide:</p>
                                    <ul>
                                        <li>High-resolution images (PNG, JPG, PDF, AI preferred)</li>
                                        <li>Clear design instructions</li>
                                        <li>Required size, format, stitch count expectations</li>
                                        <li>Thread color details (if specific)</li>
                                    </ul>
                                    <p className="case-study-description">
                                        Low-quality artwork may affect final results. If artwork requires recreation or cleanup, additional charges may apply.
                                    </p>
                                </AccordionItem>

                                <AccordionItem title="3.2 Accuracy of Information">
                                    <p className="case-study-description">Clients are responsible for verifying:</p>
                                    <ul>
                                        <li>Spelling</li>
                                        <li>Measurements</li>
                                        <li>Color selection</li>
                                        <li>Placement instructions</li>
                                    </ul>
                                    <p className="case-study-description">
                                        We are not responsible for errors approved by the client.
                                    </p>
                                </AccordionItem>

                                {/* Section 4 - with accordion subheadings */}
                                <h3 className="case-study-title">4. Pricing & Payments</h3>

                                <AccordionItem title="4.1 Payment Terms">
                                    <ul>
                                        <li>Full payment is required before final files are delivered.</li>
                                        <li>Patch production requires advance deposit or full payment.</li>
                                        <li>Prices may vary depending on design complexity, stitch count, or turnaround time.</li>
                                    </ul>
                                </AccordionItem>

                                <AccordionItem title="4.2 Payment Methods">
                                    <p className="case-study-description">We may accept:</p>
                                    <ul>
                                        <li>PayPal</li>
                                        <li>Stripe</li>
                                        <li>Bank Transfer</li>
                                        <li>Western Union</li>
                                        <li>Other approved payment methods</li>
                                    </ul>
                                </AccordionItem>

                                <AccordionItem title="4.3 Currency">
                                    <p className="case-study-description">
                                        All prices are listed in USD unless otherwise specified.
                                    </p>
                                </AccordionItem>

                                {/* Section 5 */}
                                <h3 className="case-study-title">5. Turnaround Time</h3>
                                <ul>
                                    <li>Standard digitizing: 4-12 hours.</li>
                                    <li>Vector conversion: 4-12 hours</li>
                                    <li>Custom patch production: 5-10 business days</li>
                                    <li>DTF artwork: 4-24 hours</li>
                                </ul>
                                <p className="case-study-description">
                                    Turnaround times may vary due to complex designs, revisions, high workload, or public holidays. Rush orders may incur additional fees.
                                </p>

                                {/* Section 6 */}
                                <h3 className="case-study-title">6. Revisions Policy</h3>
                                <p className="case-study-description">
                                    We provide free minor revisions within 8 hours of delivery. Minor revisions include:
                                </p>
                                <ul>
                                    <li>Small stitch density adjustments</li>
                                    <li>Thread color changes</li>
                                    <li>Minor sizing adjustments</li>
                                </ul>
                                <p className="case-study-description">
                                    Major revisions (logo redesign, complete structure changes) may require additional charges.
                                </p>

                                {/* Section 7 */}
                                <h3 className="case-study-title">7. Refund Policy</h3>
                                <p className="case-study-description">Due to the digital nature of our services:</p>
                                <ul>
                                    <li>Refunds are not available once final files have been delivered.</li>
                                    <li>If an error occurs due to our mistake, we will correct it free of charge.</li>
                                    <li>Refunds may be considered only if work has not yet started.</li>
                                    <li>Custom patch production orders are non-refundable once production begins.</li>
                                </ul>

                                {/* Section 8 - with accordion subheadings */}
                                <h3 className="case-study-title">8. Copyright & Intellectual Property</h3>

                                <AccordionItem title="8.1 Client Responsibility">
                                    <p className="case-study-description">
                                        Clients must ensure they own or have legal rights to reproduce submitted artwork.
                                    </p>
                                    <p className="case-study-description">
                                        Grand Indigo Embroidery is not liable for copyright or trademark violations in customer-submitted designs.
                                    </p>
                                </AccordionItem>

                                <AccordionItem title="8.2 Ownership of Files">
                                    <ul>
                                        <li>Upon full payment, clients receive usage rights for the final design files.</li>
                                        <li>We reserve the right to display completed designs in our portfolio unless confidentiality is requested in writing.</li>
                                    </ul>
                                </AccordionItem>

                                {/* Section 9 */}
                                <h3 className="case-study-title">9. File Testing & Liability</h3>
                                <p className="case-study-description">
                                    It is the client's responsibility to test embroidery files on their machine before bulk production. We are not responsible for:
                                </p>
                                <ul>
                                    <li>Machine calibration issues</li>
                                    <li>Thread breaks</li>
                                    <li>Fabric damage</li>
                                    <li>Improper hooping</li>
                                    <li>Production losses</li>
                                </ul>

                                {/* Section 10 */}
                                <h3 className="case-study-title">10. Limitation of Liability</h3>
                                <p className="case-study-description">Grand Indigo Embroidery shall not be liable for any:</p>
                                <ul>
                                    <li>Indirect losses</li>
                                    <li>Production downtime</li>
                                    <li>Loss of business profits</li>
                                    <li>Damage resulting from misuse of files</li>
                                </ul>
                                <p className="case-study-description">
                                    Our maximum liability shall not exceed the amount paid for the specific service.
                                </p>

                                {/* Section 11 */}
                                <h3 className="case-study-title">11. Confidentiality</h3>
                                <p className="case-study-description">
                                    We respect client confidentiality. If requested, we will not display or share your design publicly.
                                </p>

                                {/* Section 12 */}
                                <h3 className="case-study-title">12. Termination of Service</h3>
                                <p className="case-study-description">We reserve the right to refuse or terminate service if:</p>
                                <ul>
                                    <li>The client uses abusive language.</li>
                                    <li>The design contains illegal, hateful, or prohibited content.</li>
                                    <li>Payment terms are violated.</li>
                                </ul>

                                {/* Section 13 */}
                                <h3 className="case-study-title">13. Governing Law</h3>
                                <p className="case-study-description">
                                    These Terms shall be governed by applicable international business laws. Any disputes shall be resolved amicably before legal action.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />
            <Footer />
        </>
    )
}